var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3743 4.375H4.46802V2.84375C4.46802 2.43764 4.62935 2.04816 4.91651 1.76099C5.20368 1.47383 5.59315 1.3125 5.99927 1.3125C6.40538 1.3125 6.79486 1.47383 7.08203 1.76099C7.36919 2.04816 7.53052 2.43764 7.53052 2.84375C7.53052 2.95978 7.57661 3.07106 7.65866 3.15311C7.74071 3.23516 7.85199 3.28125 7.96802 3.28125C8.08405 3.28125 8.19533 3.23516 8.27738 3.15311C8.35942 3.07106 8.40552 2.95978 8.40552 2.84375C8.40552 2.20557 8.152 1.59353 7.70074 1.14227C7.24948 0.691015 6.63744 0.4375 5.99927 0.4375C5.36109 0.4375 4.74905 0.691015 4.29779 1.14227C3.84653 1.59353 3.59302 2.20557 3.59302 2.84375V4.375H1.62427C1.39228 4.37527 1.16988 4.46754 1.00584 4.63157C0.841805 4.79561 0.749533 5.01802 0.749268 5.25V11.375C0.749533 11.607 0.841805 11.8294 1.00584 11.9934C1.16988 12.1575 1.39228 12.2497 1.62427 12.25H10.3743C10.6063 12.2497 10.8287 12.1575 10.9927 11.9934C11.1567 11.8294 11.249 11.607 11.2493 11.375V5.25C11.249 5.01802 11.1567 4.79561 10.9927 4.63157C10.8287 4.46754 10.6063 4.37527 10.3743 4.375Z",
    fill: "#515151"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.d45b7f93.svg";
export { ForwardRef as ReactComponent };